import { VideoUIMaterials } from "./VideoUIMaterials";
import { Article } from "@platform/features/support/support.types";

type Props = {
  article: Article | null;
  scrollContainer?: HTMLElement | null;
};

export function VideoUIMaterialsContainer({ article, scrollContainer }: Props) {
  if (!article) return null;

  return (
    <VideoUIMaterials article={article} scrollContainer={scrollContainer} />
  );
}

export default VideoUIMaterialsContainer;
